import { BASE_PATH, IS_PROD, PUBLIC_PATH } from './envConfig';

// ─── 以下一般不需要改动，路径变量请在 envConfig.ts 修改 ─────────

export { IS_PROD };
export const APP_BASE_PATH = BASE_PATH;
export const APP_PUBLIC_PATH = PUBLIC_PATH;

console.log(APP_BASE_PATH, APP_PUBLIC_PATH, IS_PROD);

function isExternalPath(path: string) {
  return (
    /^(?:[a-z][a-z\d+\-.]*:)?\/\//i.test(path) || /^(?:data|blob):/i.test(path)
  );
}

export function withPublicPath(path: string) {
  if (!path || isExternalPath(path)) {
    return path;
  }
  return `${APP_PUBLIC_PATH}${path.replace(/^\/+/, '')}`;
}

export function stripAppBase(path: string) {
  if (!path || !APP_BASE_PATH) {
    return path;
  }
  if (path === APP_BASE_PATH) {
    return '/';
  }
  if (path.startsWith(`${APP_BASE_PATH}/`)) {
    return path.slice(APP_BASE_PATH.length) || '/';
  }
  return path;
}

export function toRouterPath(path: string | null | undefined, fallback = '/') {
  if (!path) {
    return fallback;
  }
  if (/^[a-z][a-z\d+\-.]*:/i.test(path)) {
    if (typeof window === 'undefined') {
      return fallback;
    }
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) {
      return fallback;
    }
    return stripAppBase(`${url.pathname}${url.search}${url.hash}`);
  }
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return stripAppBase(normalizedPath);
}
